export class ReassignFields {
    advisorFromId: number;
    advisorToId: number;
    observation: string;
}
